import { render } from "./ActivityStatistics.vue?vue&type=template&id=e83f8f42"
import script from "./ActivityStatistics.vue?vue&type=script&lang=js"
export * from "./ActivityStatistics.vue?vue&type=script&lang=js"

import "./ActivityStatistics.vue?vue&type=style&index=0&id=e83f8f42&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__